import React from 'react';
import PropTypes from 'prop-types';
import { TagContainer, Tag } from './Tags.styled.js';

const Tags = ({ names = [], scrollable = false }) => {
  return (
    <TagContainer scrollable={scrollable}>
      {names.map((name, index) => (
        <Tag key={`${name}-${index}`}>
          {name}
        </Tag>
      ))}
    </TagContainer>
  );
};

Tags.propTypes = {
  names: PropTypes.arrayOf(PropTypes.string),
  scrollable: PropTypes.bool
};

export default Tags; 